import { findProfileItems, visibleProfileSections } from '../profile/profileSections'
import type { Resource } from './model'

/** Share every Quick find destination, including its field anchor and audience rules. */
export function profileResources(location: string, isViewingAs: boolean): Resource[] {
  const normalized = location.trim().toLowerCase()
  const isPhilippines = normalized.includes('philippines')
  const sections = visibleProfileSections(isPhilippines, isViewingAs,
    ['sydney', 'melbourne', 'australia', 'au'].includes(normalized))
  const items = findProfileItems('', sections.map(section => section.id), isPhilippines)
  const resources: Resource[] = items.map(item => {
    const section = sections.find(section => section.id === item.section)!
    const params = new URLSearchParams({ tab: section.id })
    if (item.anchor) params.set('item', item.anchor)
    params.set('highlight', '1')
    return {
      id: `profile-${section.id}-${item.anchor || 'tab'}`,
      path: `/my-profile?${params}`,
      label: item.label,
      detail: `My profile · ${section.label}`,
      keywords: item.keywords,
      kind: 'Actions', searchCategory: 'My Profile',
      icon: section.icon,
    }
  })
  for (const section of sections) {
    const path = `/my-profile?tab=${section.id}&highlight=1`
    if (!resources.some(resource => resource.path === path)) resources.push({
      id: `profile-tab-${section.id}`, path, label: section.label,
      detail: `My profile · ${section.group}`, kind: 'Actions', searchCategory: 'My Profile', icon: section.icon,
    })
  }
  return resources
}
